// extracted by mini-css-extract-plugin
module.exports = {"rootw":"card_rootw__1citI","rooth":"card_rooth__1Y1Ui"};